const nps = {
  nps: {
    npsBreakdown: 'NPS Breakdown',
    npsScore: 'NPS Score',
    npsSpread: 'NPS Spread',
    npsDashboard: 'NPS DASHBOARD',
    npsDetails: 'NPS Details',
    npsTrend: 'NPS Trend',
    verbatims: 'Verbatims',
    timePeriod: 'Time Period : ',
    to: 'to',
    pastMonths: 'Past %{month} Months',
    ratingType: 'Rating Type',
    systemId: 'System ID',
    systemName: 'System Name',
    rating: 'Rating',
    comments: 'Comments',
    all: 'All',
    promoter: 'Promoter',
    promoters: 'Promoters',
    detractor: 'Detractor',
    detractors: 'Detractors',
    passive: 'Passive',
    noData: 'No data Available',
    npsDashboardTooltip: {
      whatIs: 'What is Net Promoter Score?',
      npsDefine:
        "The Net Promoter Score is an index ranging from -100 to 100 that measures the willingness of customers to recommend a company to others. It is used as a proxy for gauging the customer's Overall satisfaction.",
      questionIs: `Question is phrased as "On a scale of 0 to 10,how likely is it that you would recommend our organization to a friend or colleague?" Based on the number a customer chooses, they're classified into one of the following categories: "Detractors," "Passives," and "Promoters." Score breakdowns: 0 - 6: Detractors, 7 - 8: Passives, 9 - 10: Promoters`,
      determined: `The Net Promoter Score (NPS) is determined by subtracting the percentage of customers who are detractors from the percentage who are promoters. What is generated is a score between -100 and 100 called the Net Promoter Score.`,
      how: `How does Enphase determine NPS for you?`,
      shownBelow: `Enphase prompts homeowners to provide ratings in the Enlighten Mobile app as shown in below screens. Based on the ratings provided, NPS is determined as described above.`
    },
    timePeriodTooltip: `The default time period is past 13 months. If the NPS Score is not available for past 13 months, then the score is included from the first available month.`,
    verbatimsTooltip: `All the comments shown here are from system owners who have given consent to share it with the installers.`,
    jan: "Jan'",
    feb: "Feb'",
    mar: "Mar'",
    apr: "Apr'",
    may: "May'",
    jun: "Jun'",
    jul: "Jul'",
    aug: "Aug'",
    sep: "Sep'",
    oct: "Oct'",
    nov: "Nov'",
    dec: "Dec'",
    ofTotal: 'of total',
    ratings: 'Ratings',
    numberOfReviews: 'Number of Reviews',
    date: 'Date',
    between0And10: 'Please type in a value between 0 and 10',
    lessThan50: 'The number of characters should be less than 50',
    npsBasedOnScore: `NPS of %{score} based on %{count} ratings`
  }
};

export default nps;
